import type { CSSProperties } from "react";

/** 全 H5 返回：图标地址、尺寸与左间距（无背景，仅图标） */
export interface H5BackButtonConfig {
  /** public 目录下图标文件名，如 back.svg */
  iconFileName: string;
  /** 返回图标边长（px） */
  iconSize: number;
  /** 距屏幕/顶栏容器左缘（px，不含 safe-area） */
  offsetLeft: number;
}

export const H5_BACK_BUTTON = {
  iconFileName: "back.svg",
  iconSize: 16,
  offsetLeft: 16,
} as const satisfies H5BackButtonConfig;

/** 返回图标完整 URL（含 PUBLIC_URL 前缀） */
export function getH5BackButtonIconSrc(): string {
  const base = process.env.PUBLIC_URL || "";
  const file = H5_BACK_BUTTON.iconFileName.replace(/^\//, "");
  return `${base}/${file}`;
}

/** 返回按钮 CSS 变量，注入页面根节点即可 */
export function h5BackButtonCssVars(): CSSProperties {
  return {
    ["--h5-back-icon-size" as string]: `${H5_BACK_BUTTON.iconSize}px`,
    ["--h5-back-offset-left" as string]: `${H5_BACK_BUTTON.offsetLeft}px`,
  };
}
